<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.proposal.publishByMemberReferred.p1')}}
    {{news.textParams[2]}}
    "<router-link :to="{name: 'ProposalView', params: {id: news.textParams[3]}}">
    {{news.textParams[4]}}</router-link>"
    {{$t('news.template.proposal.publishByMemberReferred.p2')}}
    <a href="#">{{news.textParams[6]}}</a>.
    <a href="#">{{news.textParams[6]}}</a>
    {{$t('news.template.proposal.publishByMemberReferred.p3')}}
    {{news.textParams[2]}}
    {{$t('news.template.proposal.publishByMemberReferred.p4')}}
    {{news.textParams[8]}}.
    {{$t('news.template.proposal.publishByMemberReferred.p5')}}
    {{news.textParams[7]}}
    <a href="#">
      {{$t('news.template.proposal.publishByMemberReferred.p6')}}
    </a>
    {{$t('news.template.proposal.publishByMemberReferred.p7')}}
  </div>
</template>
